// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"31d6cfe0","458":"0574eefa"}[chunkId] + ".chunk.css";
};